import preLoader from '@/config/mixins/preLoader'

export default {
    data() {
        return {
            dados: {
                razao_social: '',
                nome_fantasia: '',
                cpf_cnpj: '',
                cep: '',
                rua: '',
                num: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
                inscricao_estadual: ''
            }
        }
    },
    mixins: [preLoader],
    methods: {
        buscaEmpresa() {
            var loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + "get_cnpj", this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.errors = '';
                        this.dados.razao_social = response.data.dados.razao_social;
                        this.dados.nome_fantasia = response.data.dados.nome_fantasia;
                        this.dados.cep = response.data.dados.cep;
                        this.dados.rua = response.data.dados.rua;
                        this.dados.num = response.data.dados.num;
                        this.dados.complemento = response.data.dados.complemento;
                        this.dados.bairro = response.data.dados.bairro;
                        this.dados.cidade = response.data.dados.cidade;
                        this.dados.uf = response.data.dados.uf;
                        this.dados.inscricao_estadual = response.data.dados.inscricao_estadual;
                    } else if (response.data.errors) {
                        this.errors = response.data.errors;
                        let erros = '';
                        for (let erro of Object.values(response.data.errors)) {
                            erros += "<li>" + erro + "</li>";
                        }
                        toastr.error("<ul>" + erros + "</ul>", "ERRO");
                    } else {
                        this.errors = '';
                        toastr.error(response.data.message, 'ERRO');
                    }
                })
                .catch(e => {
                    toastr.error(e, 'ERRO');
                })
                .finally(function () {
                    loader.hide()
                })
        },
    }
}
